import { useSelector, shallowEqual } from "react-redux";
import BookingAside from "./BookingAside.jsx";
import { shouldEnableFlexRateChoice } from "app/pages/Booking/Quotation/flexSelectors";
import {
	checkIsCreditUsageIsEnabled,
	getAvailablePaymentTerms,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import {
	calculateCreditBasedOnQuoteBase,
	calculatePreBookTotal,
	isBookingDateEligibleForDeposit,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import {
	getFlightOptionsStatus,
	getPrebookStatus,
	getQuoteStatus,
} from "app/pages/Booking/Quotation/quotationSelectors";
import { FLIGHT_OPTIONS_STATUS, PRE_BOOK_CODE_STATUS, QUOTATION_CODE_STATUS } from "app/constants";
import { getHidePhoneContactUs } from "app/reducers/brandSelector";

const mapStateToProps = state => {
	const isCreditEnabled = checkIsCreditUsageIsEnabled(state);
	const creditsApplied = isCreditEnabled ? calculateCreditBasedOnQuoteBase(state) : 0;
	const total = calculatePreBookTotal(state) - creditsApplied;
	const passengersCount = state.booking.adults + state.booking.children;
	const pricePerPerson = passengersCount > 0 ? Math.floor(total / passengersCount) : 0;

	const quoteStatus = getQuoteStatus(state);
	const flightOptionsStatus = getFlightOptionsStatus(state);
	const prebookStatus = getPrebookStatus(state);

	const isQuoteLoading =
		quoteStatus === QUOTATION_CODE_STATUS.LOADING ||
		flightOptionsStatus === FLIGHT_OPTIONS_STATUS.LOADING;

	return {
		shop: state.shop,
		total: total,
		pricePerPerson: pricePerPerson,
		ficheProduit: state.ficheProduit,
		depositPercentage: getPartnerDepositPercentage(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		enableFlexRateChoice: shouldEnableFlexRateChoice(state),
		isSubmitting: prebookStatus === PRE_BOOK_CODE_STATUS.LOADING,
		isQuoteLoading,
		availablePaymentTerms: getAvailablePaymentTerms(state),
		isBookingDateEligibleForDeposit: isBookingDateEligibleForDeposit(state),
		enableDepositDisplay: isDepositEnabled(state),
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		hidePhoneContactUs: getHidePhoneContactUs(state),
	};
};

const BookingAsideContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <BookingAside {...props} {...stateProps} />;
};

export default BookingAsideContainer;
